const STORAGE_KEY = 'empiremaps_last_league';
const DEFAULT_LEAGUE = 'ncaa_basketball';

const LEAGUE_PATHS: Record<string, string> = {
    ncaa_basketball: '/league/ncaa_basketball',
    ncaa_football: '/league/ncaa_football',
    nba: '/league/nba',
    nhl: '/league/nhl',
    nfl: '/league/nfl',
    mlb: '/league/mlb',
    mls: '/league/mls',
    ufc: '/ufc',
    naming_wars: '/naming-wars/map',
};

export function getLastLeagueMapPath(): string {
    try {
        const id = localStorage.getItem(STORAGE_KEY);
        if (id && LEAGUE_PATHS[id]) return LEAGUE_PATHS[id];
    } catch {
        /* private mode */
    }
    return LEAGUE_PATHS[DEFAULT_LEAGUE];
}

/** Remember the last map the user opened (powers the Map nav item). */
export function rememberLeagueFromPath(pathname: string): void {
    let id: string | null = null;
    const leagueMatch = pathname.match(/^\/league\/([^/]+)/);
    if (leagueMatch) id = leagueMatch[1];
    else if (pathname === '/ufc' || pathname.startsWith('/ufc/')) id = 'ufc';
    else if (pathname.startsWith('/naming-wars')) id = 'naming_wars';

    if (!id || !LEAGUE_PATHS[id]) return;
    try {
        localStorage.setItem(STORAGE_KEY, id);
    } catch {
        /* private mode */
    }
}

export function isMapPath(pathname: string): boolean {
    return (
        pathname.startsWith('/league/') ||
        pathname === '/ufc' ||
        pathname.startsWith('/ufc/') ||
        pathname.startsWith('/naming-wars')
    );
}
